import { pick, filter, get, isNil } from 'lodash';

function checkSelected(dataObj) {
  let picked = pick(dataObj, [
    'Categories',
    'Zones',
    'ExperiencesList',
    'ScopesList',
    'FrequencyPreferencesList'
  ]);

  for (const property in picked) {
    picked[property] = filter(picked[property], 'IsSelected');
  }

  return picked;
}

function extractSelectedValues(arr) {
  if (!isNil(arr)) {
    let codesArr = [];
    arr.forEach(item => {
      if (item.Code) codesArr.push(item.Code);
      else codesArr.push(item);
    });
    return codesArr;
  }
}

const actions = {
  fetchUserData({ commit, state }) {
    let selected = checkSelected(state.allSettingsData);

    let usersCategories = get(selected, 'Categories');
    let temp = extractSelectedValues(usersCategories);

    let usersZones = get(selected, 'Zones');
    temp = extractSelectedValues(usersZones);
    commit('SET_ZONES', temp);

    let usersScopes = get(selected, 'ScopesList');
    temp = extractSelectedValues(usersScopes);
    commit('SET_SCOPE', temp);

    let usersExperience = get(selected, 'ExperiencesList');
    temp = extractSelectedValues(usersExperience);
    commit('SET_EXPERIENCE', temp);

    let usersMailingFrequencies = get(selected, 'FrequencyPreferencesList');
    temp = extractSelectedValues(usersMailingFrequencies);
    commit('SET_MAILING_PREFERENCES', temp);

    let userAlertsType = get(selected, 'AlertTypes');
    temp = extractSelectedValues(userAlertsType);
    commit('SET_ALERTS_TYPES', temp);

    let userKeywordsJD = get(state.allSettingsData, 'Keywords');
    temp = extractSelectedValues(userKeywordsJD);
    commit('SET_KEYWORDS_JD', temp);

    commit('INITIALIZE');
  },

  setMainCategory({ commit }, category) {
    commit('SET_MAIN_CATEGORY', category);
  },

  setMainSubCategories({ commit }, subCategoriesArr) {
    commit('SET_MAIN_SUB_CATEGORIES', subCategoriesArr);
  },

  setSecondaryCategory({ commit }, category) {
    commit('SET_SECONDARY_CATEGORY', category);
  },

  setSecondarySubCategories({ commit }, subCategoriesArr) {
    commit('SET_SECONDARY_SUB_CATEGORIES', subCategoriesArr);
  },

  setLocations({ commit }, locations) {
    commit('SET_LOCATIONS', locations);
  },

  setZones({ commit }, zonesArr) {
    commit('SET_ZONES', zonesArr);
  },

  setScope({ commit }, scopesArr) {
    commit('SET_SCOPE', scopesArr);
  },

  setExperience({ commit }, experience) {
    commit('SET_EXPERIENCE', experience);
  },

  setAudience({ commit }, audienceArr) {
    commit('SET_AUDIENCE', audienceArr);
  },

  setMailing({ commit }, booleanVal) {
    commit('SET_MAILING', booleanVal);
  },

  setMailingPreferences({ commit }, mailingFrequency) {
    commit('SET_MAILING_PREFERENCES', mailingFrequency);
  },

  setAlertTypes({ commit }, alertTypes) {
    commit('SET_ALERTS_TYPES', alertTypes);
  },

  setKeywordsJD({ commit }, keywordsArr) {
    commit('SET_KEYWORDS_JD', keywordsArr);
  },

  resetLocalState({ commit }) {
    commit('RESET_LOCAL_STATE');
  }
};

export default actions;
